var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .372c3.871 0 7 3.139 7 7.007a6.997 6.997 0 01-7 7.006c-3.864 0-7-3.132-7-7.006C0 3.51 3.136.372 7 .372zm-.245 3.454a.525.525 0 00-.525.526V7.89c0 .182.098.35.259.449l2.744 1.64a.52.52 0 00.721-.182.528.528 0 00-.182-.723L7.28 7.59V4.352a.525.525 0 00-.525-.526z"
  })));
}

export default __webpack_public_path__ + "20aeecf6c115fc8712c7d6ec10130c06.svg";
export { SvgClock as ReactComponent };